export const pxToRem = (px: number): string => `${px / 16}rem`;
